import LeafRectangleLoader from "../../../../leaf/LeafLoadingSkeleton/LeafRectangleLoader/LeafRectangleLoader";
import "./VolumeRequirementLoader.scss";

export const VolumeRequirementLoader = ({
  border = true,
  showHeader = true,
}: {
  border?: boolean;
  showHeader?: boolean;
}) => {
  return (
    <div className={`VolumeRequirementLoader ${border ? `VolumeRequirementLoader--border` : ""}`.trim()}>
      {showHeader && <LeafRectangleLoader isLoading={true} width="100%" height="3.5rem" margin="0 0 1.5rem 0" />}
      <div className="VolumeRequirementLoader__content">
        <div className="VolumeRequirementLoader__donut"></div>
      </div>
    </div>
  );
};
